import styled from "@rentiohq/shared-frontend/dist/components/theme/styled-components";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { EInfoHeaderStyle } from "./InfoHeader.types";

export const Wrap = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  align-items: flex-start;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const Title = styled.span<{ titleStyle?: EInfoHeaderStyle }>`
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: ${props => {
    switch (props.titleStyle || EInfoHeaderStyle.Regular) {
      case EInfoHeaderStyle.Warning:
        return props.theme.colors.warningText;

      case EInfoHeaderStyle.Regular:
      default:
        return props.theme.colors.neutral1;
    }
  }};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    font-size: 30px;
  }
`;

export const Body = styled.span<{ bodyStyle?: EInfoHeaderStyle }>`
  display: block;
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  color: ${props => {
    switch (props.bodyStyle || EInfoHeaderStyle.Regular) {
      case EInfoHeaderStyle.Warning:
        return props.theme.colors.warningText;

      case EInfoHeaderStyle.Regular:
      default:
        return props.theme.colors.neutral1;
    }
  }};
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-top: 12px;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const ButtonPrimaryWrap = styled.div`
  margin-top: 8px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-top: 16px;
  }
`;

export const ButtonBasicWrap = styled.div`
  margin-top: 4px;
  @media ${CONFIG.RESPONSIVE.BREAKPOINT.DESKTOP} {
    margin-top: 8px;
  }
`;
